<template>
    <el-container style="height:100%;width:100%; display:flex;flex-direction: column;">
        <BackHead @checkaside="isCollapse=!isCollapse" :flag="isCollapse"/>
        <el-container >
            <el-menu :collapse="isCollapse" active-text-color="#407BDB" class="el-menu-vertical-demo" unique-opened :index="this.$router.path" router style="overflow:hidden">
                <div class="logo" @click="showHome">
                    <div class="logo1">
                        <img src="../assets/images/home.webp" style="width:17px;height:16px"/>
                        <span style="margin-left:10px">首页</span>
                    </div>
                </div>
                <el-submenu :index="item.id+''" v-for="item in menuList" :key="item.id">
                    <template slot="title" class="title">
                        <i :class="item.icon"></i>
                        <span slot="title" style="fontSize:15px">{{item.title}}</span>
                    </template>
                    <el-menu-item :index="value.href" v-for="(value, index) in item.children" :key="index" >
                        <template slot="title">
                            <span slot="title" style="margin-left:20px;">{{value.title}}</span>
                        </template>
                    </el-menu-item>
                </el-submenu>
            </el-menu>
            <el-main>
                <transition name="nodebook" mode="out-in">
                    <router-view />
                </transition>
            </el-main>
        </el-container>
  </el-container>

</template>

<script>
export default {
  name: "Home",
  data(){
      return{
          isCollapse:false,
          menuList:[],
      }
  },
  created() {
      this.$api.GetMenuList().then(res=>{
          this.menuList = JSON.parse(res.data.data)
      })
  },
  mounted() {
      
  },
  methods:{
      showHome(){
          if(this.$route.path == '/Home') return
          this.$router.push('/Home')
      },
  },
  watch:{
  }
};
</script>

<style lang="scss" scoped>
.logo{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo1{
    height: 75%;
    width: 85%;
    border-radius: 20px;
    display: flex;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 9px;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    background-color: #407BDB;
}
.el-menu{
    border: none;
    background-color: #FFFFFF;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}
// .el-menu-item.is-active {
//     color: #407BDB !important;
// }
.el-submenu .el-menu-item{
    min-width: 0 !important;
}
.el-menu-item.is-active{
    color: #fff !important;
    width: 150px !important;
    height: 45px;
    padding-left: 22px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #407BDB !important;
    border-radius: 20px;
    margin: 0 auto;
}
.el-main{
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: #eee;
}
.nodebook-enter, .nodebook-leave-to{
    transform: scale(0.9);
    opacity: 0;
}
.nodebook-enter-to, .nodebook-leave{
    transform: scale(1);
    opacity: 1;
}
.nodebook-enter-active, .nodebook-leave-active {
    transition: all 0.3s;
}

</style>